require('./cocos2d/UserDefault')
require('./cocos2d/ClippingRectangleNode')
require('./cocos2d/SpriteWithHue')
require('./cocos2d/TiledSprite')
require('./cocos2d/loader')

cc.SimpleAudioEngine = {
    getInstance() {
        var instance = cc.audioEngine
        if (window.mini &&
            (window.mini.getPlatform() == MiniPlatform.oppoQuickgame ||
            window.mini.getPlatform() == MiniPlatform.vivo)){
            instance._checkAudioStop = true
        }
        return instance
    }
}

cc.audioEngine.preloadMusic = cc.audioEngine.preloadEffect = function (path) {
    cc.loader.load(path)
}

cc.audioEngine.pauseMusic = function () {
    //cc.log("music pause* "+( this._currMusic!=null?this._currMusic.__instanceId:" empty" ) )
    if (window.MusicPlayer)
        MusicPlayer.getInstance().enterBackground();
}

cc.audioEngine.resumeMusic = function () {
    //cc.log("music resume* "+( this._currMusic!=null?this._currMusic.__instanceId:" empty" ) )
    if (window.MusicPlayer)
        MusicPlayer.getInstance().enterForeground();
}

cc.Director.getInstance = cc.Director._getInstance
cc.Director.prototype.getAvgFrameRate = function () {
    return cc.profiler.getFrameRate()
}

cc.setmethods = function (target, component, methods) {
    // for _, name in ipairs(methods) do
    //     local method = component[name]
    //     target[name] = function(__, ...)
    //         return method(component, ...)
    //     end
    // end
}

cc.unsetmethods = function (target, methods) {
    // for _, name in ipairs(methods) do
    //     target[name] = nil
    // end
}

cc.CSLoader = {
    createNode(file, path = '') { return ccs._load(file, null, path) },
    createTimeline(file, path = '') { return ccs._load(file, "action", path) }
}
cc.CSLoader.createTimeline = ccs.actionTimelineCache.createAction

cc.Director.getInstance = cc.Director._getInstance
cc.Director.prototype.getTextureCache = function () {
    return cc.textureCache
}
cc.Label = cc.LabelTTF
cc.Label.createWithSystemFont = cc.LabelTTF.create
cc.LabelTTF.prototype.setAlignment = cc.LabelTTF.prototype.setHorizontalAlignment

cc.Label.createWithBMFont = function (bmfontPath, text, textAlignment, maxLineWidth, imageOffset) {
    var f = ResourceFntPixelFormat[bmfontPath]
    cc.Texture2D.setDefaultAlphaPixelFormat(f)
    var ret = cc.LabelBMFont.create(text, bmfontPath, maxLineWidth, textAlignment, imageOffset)
    cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_BGR_A8888)
    return ret
}

cc.LabelBMFont.prototype._additionalKerning = 0
/**
 * 由于flash中采用的是矢量图，游戏内为贴图，导致BMFont达不到美术想要的效果，因此设置该变量用以解决该问题，各字之间的间距偏移量，默认为0不改变
 */
cc.LabelBMFont.prototype.nextFontPositionXOffset = 0
/**
 *  设定字体间距偏移量，设定完成后用setString来刷新效果
 */
cc.LabelBMFont.prototype.setNextFontPositionXOffset = function (offset) {
    var self = this;
    self.nextFontPositionXOffset = offset;
}
cc.LabelBMFont.prototype.setAdditionalKerning = function (val) { this._additionalKerning = val }
cc.LabelBMFont.prototype.createFontChars = function () {
    var self = this;
    var locStr = self._string;
    var stringLen = locStr ? locStr.length : 0;
    if (stringLen === 0)
        return;
    var cmd = this._renderCmd;
    var locTexture = cmd._texture || this._texture;
    var nextFontPositionX = 0;
    var tmpSize = cc.size(0, 0);
    var longestLine = 0;
    var quantityOfLines = 1;
    var i, locCfg = self._config, locKerningDict = locCfg.kerningDict, locCommonH = locCfg.commonHeight, locFontDict = locCfg.fontDefDictionary;
    for (i = 0; i < stringLen - 1; i++) {
        if (locStr.charCodeAt(i) === 10)
            quantityOfLines++;
    }
    var totalHeight = locCommonH * quantityOfLines;
    var nextFontPositionY = -(locCommonH - locCommonH * quantityOfLines);
    var prev = -1;
    var fontDef;
    for (i = 0; i < stringLen; i++) {
        var key = locStr.charCodeAt(i);
        if (key === 0)
            continue;
        if (key === 10) {
            nextFontPositionX = 0;
            nextFontPositionY -= locCfg.commonHeight;
            continue;
        }
        var kerningAmount = locKerningDict[(prev << 16) | (key & 0xffff)] || 0;
        kerningAmount += this._additionalKerning
        fontDef = locFontDict[key];
        if (!fontDef) {
            cc.log("cocos2d: LabelBMFont: character not found " + locStr[i] + " in " + locCfg.atlasName);
            fontDef = {
                rect: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                },
                xOffset: 0,
                yOffset: 0,
                xAdvance: 0
            };
            
            // DCAssist.tryLackOfFont(locStr[i], locCfg.atlasName);
            if (__DEBUG){//加字体使用
                window.nofont = window.nofont || {}
                window.nofont[locCfg.atlasName] = window.nofont[locCfg.atlasName] || ""
                window.nofont[locCfg.atlasName] += locStr[i]
            }
          
        } else {
            // DCAssist.tryUseFont(locStr[i], locCfg.atlasName);
        }
        var rect = cc.rect(fontDef.rect.x, fontDef.rect.y, fontDef.rect.width, fontDef.rect.height);
        rect = cc.rectPixelsToPoints(rect);
        rect.x += self._imageOffset.x;
        rect.y += self._imageOffset.y;
        var fontChar = self.getChildByTag(i);
        if (!fontChar) {
            fontChar = new cc.Sprite();
            fontChar.initWithTexture(locTexture, rect, false);
            fontChar._newTextureWhenChangeColor = true;
            this.addChild(fontChar, 0, i);
        } else {
            cmd._updateCharTexture(fontChar, rect, key);
        }
        fontChar.opacityModifyRGB = this._opacityModifyRGB;
        cmd._updateCharColorAndOpacity(fontChar);
        var yOffset = locCfg.commonHeight - fontDef.yOffset;
        var fontPos = cc.p(nextFontPositionX + fontDef.xOffset + fontDef.rect.width * 0.5 + kerningAmount, nextFontPositionY + yOffset - rect.height * 0.5 * cc.contentScaleFactor());
        fontChar.setPosition(cc.pointPixelsToPoints(fontPos));
        nextFontPositionX += fontDef.xAdvance + kerningAmount + self.nextFontPositionXOffset;
        prev = key;
        if (longestLine < nextFontPositionX)
            longestLine = nextFontPositionX;
    }
    if (fontDef && fontDef.xAdvance < fontDef.rect.width)
        tmpSize.width = longestLine - fontDef.xAdvance + fontDef.rect.width;
    else
        tmpSize.width = longestLine;
    tmpSize.height = totalHeight;
    self.setContentSize(cc.sizePixelsToPoints(tmpSize));
}
cc.LabelBMFont.prototype.setDimensions = function name(params) {
    cc.warn('cc.LabelBMFont.prototype.setDimensions is not implement')
}
cc.LabelBMFont.prototype.setHorizontalAlignment = function () { cc.warn('cc.LabelBMFont.prototype.setHorizontalAlignment is not implement') }
cc.LabelTTF.prototype.setTextColor = cc.LabelTTF.prototype.setFontFillColor

cc.Animation.createWithSpriteFrames = cc.Animation.create

cc.Sprite.createWithSpriteFrameName = function (fileName, rect, rotated) {
    // 强制从spriteFrameCache中获取
    if (fileName && fileName[0] !== '#') {
        let frame = cc.spriteFrameCache.getSpriteFrame(fileName)
        if (frame) {
            fileName = '#' + fileName
        }
    }
    return new cc.Sprite(fileName, rect, rotated)
}

// FIXME: sprite
cc.Sprite.prototype.setGroupRenderPass = function () { }
cc.Node.prototype.setGroupRenderPass = function () { }
cc.Node.prototype.clearGroupRenderPasses = function () { }
cc.Sprite.prototype.setFilter = function () { }

cc.SpriteFrame.prototype.retain = function () { }
// TODO: release
cc.SpriteFrame.prototype.release = function () { }

// 与场景相关的纹理释放
// 这里的主要目的是释放游戏场景中的纹理
// 对于有加载场景的情况，目前的简单方案是在将载场景resRefName设为对应目标场景
// cc.Scene.prototype.setResRefName = function (val) {
//     this.resRefName = val
// }

// cc.Scene.prototype.getResRefName = function (val) {
//     return this.resRefName || this._name || this.name
// }

// FIXME: 对于同场景内的加载卸载，这种方式会有问题，暂时取消
// let oldRemoveTextureForKey = cc.textureCache.removeTextureForKey
// cc.textureCache.removeTextureForKey = function (textureKeyName) {
//     oldRemoveTextureForKey.call(this, textureKeyName)
//     if (textureKeyName == null)
//         return
//     let texture = this._textures[textureKeyName]
//     if (texture && texture.refNames) {
//         texture.removeRefName()
//         if (Object.keys(texture.refNames).length < 1) {
//             texture.releaseTexture()
//             delete this._textures[textureKeyName]
//         }
//     }
// }

// let oldCacheImage = cc.textureCache.cacheImage
// cc.textureCache.cacheImage = function (path, texture) {
//     oldCacheImage.apply(this, arguments)
//     let t = this._textures[path]
//     t.addRefName()
// }

// let oldAddUIImage = cc.textureCache.addUIImage
// cc.textureCache.addUIImage = function (image, key) {
//     let texture = oldAddUIImage.apply(this, arguments)
//     texture.addRefName()
//     return texture
// }

cc.game.addEventListener(cc.game.EVENT_RENDERER_INITED, function () {
    cc.Texture2D.prototype.retain = function () { this.refnum++ }
    cc.Texture2D.prototype.release = function () { this.refnum-- }

    cc.Texture2D.setDefaultAlphaPixelFormat = function (format) {
        cc.Texture2D.defaultPixelFormat = format
    }

    // cc.Texture2D.prototype.addRefName = function (refName) {
    //     if (!refName) {
    //         let refScene = cc.director.getRunningScene()
    //         if (refScene) {
    //             refName = refScene.getResRefName()
    //         }
    //     }
    //     if (refName) {
    //         if (!this.refNames) {
    //             this.refNames = {}
    //         }
    //         this.refNames[refName] = true
    //     }

    // }

    // cc.Texture2D.prototype.removeRefName = function (refName) {
    //     if (!refName) {
    //         let currentScene = cc.director.getRunningScene()
    //         if (currentScene) {
    //             refName = currentScene.getResRefName()
    //         }
    //     }
    //     if (this.refNames && refName) {
    //         delete this.refNames[refName]
    //     }
    // }

    // let oldAddImage = cc.textureCache.addImage
    // cc.textureCache.addImage = function (url, cb, target) {
    //     let texture = oldAddImage.apply(this, arguments)
    //     texture.addRefName()
    //     return texture
    // }
})

cc.RenderTexture.prototype.endToLua = cc.RenderTexture.prototype.end

cc.eventManager.addEventListenerWithSceneGraphPriority = cc.eventManager.addListener

cc.FileUtils = cc.Class.extend({
    getStringFromFile(path, callback) {

    },
    fullPathForFilename() {
        return null
    },
    isFileExist(ckfile){
        return cc.sys.localStorage.getItem(ckfile) !== null
    }
})

let _FileUtils = null
cc.FileUtils.getInstance = function () {
    if (!_FileUtils) {
        _FileUtils = new cc.FileUtils()
    } else {
        return _FileUtils
    }
}

cc.Node.prototype.getEventDispatcher = function () {
    return cc.eventManager
}

let oldNodeCleanup = cc.Node.prototype.cleanup
cc.Node.prototype.cleanup = function () {
    if (typeof this.onCleanup === 'function') {
        this.onCleanup()
    }
    if (typeof this.dispose === 'function') {
        this.dispose()
    }
    oldNodeCleanup.call(this)
}

cc.game.addEventListener(cc.game.EVENT_RENDERER_INITED, function () {
    let oldDrawDot = cc.DrawNode.prototype.drawDot
    cc.DrawNode.prototype.drawDot = function (center, radius, color) {
        let c4b = cc.convertColor(color, '4b')
        oldDrawDot.call(this, center, radius, c4b)
    }
})

// 只有一处用到，简单实现，不支持线段
cc.DrawNode.prototype.drawSolidCircle = function (center, radius, angle, segments, scaleX, scaleY, color) {
    this.drawDot(center, radius, color)
    this.scaleX = scaleX
    this.scaleY = scaleY
}

let scheduleScriptFuncKey = 0
cc.Scheduler.prototype.scheduleScriptFunc = function (callback, interval, paused) {
    this.schedule(callback, cc.director, interval, paused, ++scheduleScriptFuncKey)
    return scheduleScriptFuncKey
}

cc.Scheduler.prototype.unscheduleScriptEntry = function (id) {
    this.unschedule(id, cc.director)
}

cc.Layer.prototype.registerScriptTouchHandler = function (handler, bIsMultiTouches, nPriority, bSwallowsTouches) {
    this.touchListener = cc.EventListener.create({
        event: cc.EventListener.TOUCH_ONE_BY_ONE,
        // When "swallow touches" is true, then returning 'true' from the onTouchBegan method will "swallow" the touch event, preventing other listeners from using it.
        swallowTouches: bSwallowsTouches,
        //onTouch event callback function                      
        onTouchBegan: handler,
        onTouchMoved: handler,
        onTouchEnded: handler,
        onTouchCancelled: handler
    });
    cc.eventManager.addListener(this.touchListener, this);
}

cc.Layer.prototype.unregisterScriptTouchHandler = function () {
    cc.eventManager.removeListener(this.touchListener)
}

cc.Layer.prototype.setTouchEnabled = function (bool) { }

ccui.Layout.prototype.registerScriptTouchHandler = cc.Layer.prototype.registerScriptTouchHandler
ccui.Layout.prototype.unregisterScriptTouchHandler = cc.Layer.prototype.unregisterScriptTouchHandler

ccui.EditBox = cc.EditBox
ccui.EditBox.prototype.registerScriptEditBoxHandler = function (handler) {
    let self = this
    // 效率起见，未使用cc.EditBoxDelegate
    let delegate = {
        editBoxEditingDidBegin() {
            handler.call(self, 'began', self)
        },
        editBoxEditingDidEnd() {
            handler.call(self, 'ended', self)
        },
        editBoxTextChanged() {
            handler.call(self, 'changed', self)
        },
        editBoxReturn() {
            handler.call(self, 'return', self)
        }
    }
    this.setDelegate(delegate)
}

ccui.EditBox.prototype.unregisterScriptTouchHandler = function () {
    this.setDelegate(null)
}

ccui.Text.prototype.setFontStyle = function(style = "normal") {
    var renderer = this._labelRenderer
    renderer._renderCmd._setFontStyle(renderer._fontName, renderer._fontSize, style, renderer._fontWeight);
    renderer._setUpdateTextureDirty();
}

ccui.Text.prototype.setFontWeight = function(fontWeight) {
    var renderer = this._labelRenderer
    renderer._setFontWeight(fontWeight);
}

cc.EventListenerTouchOneByOne = cc._EventListenerTouchOneByOne

cc.EventListener.prototype.registerScriptHandler = function (handler, eventName) {
    switch (eventName) {
        case cc.Handler.EVENT_TOUCH_BEGAN: this.onTouchBegan = handler; break;
        case cc.Handler.EVENT_TOUCH_MOVED: this.onTouchMoved = handler; break;
        case cc.Handler.EVENT_TOUCH_ENDED: this.onTouchEnded = handler; break;
    }
}

// handle table
let oldCCSequence = cc.Sequence.create
cc.Sequence.create = function (tempArr) {
    var arr = (tempArr instanceof Array) ? tempArr : Array.prototype.slice.call(arguments)
    arr = $tableToArray(arr)
    return oldCCSequence(arr)
}

let oldCCSpawn = cc.Spawn.create
cc.Spawn.create = function (tempArr) {
    var arr = (tempArr instanceof Array) ? tempArr : Array.prototype.slice.call(arguments)
    arr = $tableToArray(arr)
    return oldCCSpawn(arr)
}

let oldBezierTo = cc.BezierTo.create
cc.BezierTo.create = function (t, c) {
    return oldBezierTo(t, $tableToArray(c))
}

let oldBezierBy = cc.BezierBy.create
cc.BezierBy.create = function (t, c) {
    return oldBezierBy(t, $tableToArray(c))
}

cc.ParticleSystemQuad = cc.ParticleSystem
cc.FilteredSpriteWithOne = cc.Sprite

cc.EventListenerAcceleration = cc._EventListenerAcceleration
// cc.PhysicsSprite.prototype.setPhysicsBody = cc.PhysicsSprite.prototype.setBody
// Box2D.Dynamics.b2World.prototype.createBody = Box2D.Dynamics.b2World.prototype.CreateBody
// // Box2D.Dynamics.b2Body.prototype.addFixture = Box2D.Dynamics.b2Body.prototype.CreateFixture
// Box2D.Dynamics.b2Body.prototype.setAngularDamping = Box2D.Dynamics.b2Body.prototype.SetAngularDamping
// Box2D.Dynamics.b2Body.prototype.getPosition = Box2D.Dynamics.b2Body.prototype.GetPosition
// Box2D.Dynamics.b2Body.prototype.applyLinearImpulse = Box2D.Dynamics.b2Body.prototype.ApplyImpulse
// Box2D.Collision.Shapes.b2EdgeShape.prototype.Copy = function () {
//     let copy_shape = new Box2D.Collision.Shapes.b2EdgeShape(this.m_v1, this.m_v2)
//     return copy_shape
// }

// 在C++实现中
cc.Node.prototype.getRotationSkewX = function () {
    return 0.0
}
cc.Node.prototype.getRotationSkewY = function () {
    return 0.0
}
// cc.Node.prototype.getRotationSkewX = cc.Node.prototype.getRotationX
// cc.Node.prototype.getRotationSkewY = cc.Node.prototype.getRotationY

// C++ 版本中 removeAllActionsByTag 与 removeAllActionsByTag 实现一致
cc.ActionManager.prototype.removeAllActionsByTag = cc.ActionManager.prototype.removeActionByTag
cc.Node.prototype.stopAllActionsByTag = function (tag) {
    this.actionManager && this.actionManager.removeAllActionsByTag(tag, this);
}

/**
 * 使用action配置播放动画（可通过CloverH5Anim.jsfl创建） 
 */
cc.Node.prototype.runActionByConfig = function (actionCfg) {
    //TODO: cache actions
    let _getGlobalFuncByPath = function (path) {
        let func = getObjectByPath(path)
        if (typeof func == "function") {
            return func
        }
        return null
    }

    let _calParams = function (paramCfg) {
        if (paramCfg instanceof Array) {
            let resultList = []
            for (let i = 0; i < paramCfg.length; i++) {
                let value = null;
                if (typeof paramCfg[i] == "object") {
                    value = _calParams(paramCfg[i])[0]
                }else{
                    value = paramCfg[i]
                }
                resultList.push(value)
            }
            return resultList
        }else{
            for (const key in paramCfg) {
                let globalFunc = _getGlobalFuncByPath(key)
                let values = paramCfg[key]
                return [globalFunc.apply(null, _calParams(values))]
            }
        }
    }

    let _applyParams = function (node, cfg) {
        for (const key in cfg) {
            if (node[key]) {
                const childFunc = node[key];
                const childFuncParams = _calParams(cfg[key])
                childFunc.apply(node,childFuncParams)
            }
        }
    }

    if (this.getName() == actionCfg["Name"]) {
        _applyParams(this, actionCfg)
        let actionParams = _calParams(actionCfg["Action"])
        this.runAction.apply(this, actionParams)
    }else{
        throw Error("Node name does not match action config.")
    }
}

/**
 * 使用action配置播放子节点动画（可通过CloverH5Anim.jsfl创建）
 */
cc.Node.prototype.runChildrenActionByConfig = function (actionCfg) {
    if (actionCfg instanceof Array) {
        for (let i = 0; i < actionCfg.length; i++) {
            let child = this.getChildByName(actionCfg[i]["Name"])
            child.runActionByConfig(actionCfg[i])
        }
    }else{
        throw Error("The configuration format must be an array. If you want to play action on this node(not children), use runActionByConfig instead.")
    }
}

/**
 * 通过action配置文件播放动画
 */
cc.Node.prototype.runActionByFile = function (file) {
    var actionsCfg = cc.loader.getRes(file);
    if (!actionsCfg)
        return cc.log("%s does not exist", file);
    this.runActionByConfig(actionsCfg)
}

/**
 * 通过action配置文件播放动画
 */
cc.Node.prototype.runChildrenActionByFile = function (file) {
    var actionsCfg = cc.loader.getRes(file);
    if (!actionsCfg)
        return cc.log("%s does not exist", file);
    this.runChildrenActionByConfig(actionsCfg)
}
// let oldLoadAliases = cc.loader.loadAliases
// cc.loader.loadAliases = function (data) {
// }

cc.loader.heLoadAliases = function (data, callback) {
    var self = this
    let realResList = dealAliaseRes(data)
    self._handleAliases(realResList, callback);
}

cc.Label.prototype.setGroupRenderPass = function () {
   cc.warn("implement me") 
}

/**
 *  设定字体间距偏移量，设定完成后用setString来刷新效果
 */
ccui.TextBMFont.prototype.setNextFontPositionXOffset = function (offset) {
    this._labelBMFontRenderer.nextFontPositionXOffset = offset;
}

/**
 * 类setTimeout，时间以cocos引擎时间为依据 
 * @oaram func 回调函数
 * @param time 秒
 */
setCCTimeOut = function(func, time) {
    let scriptId;
    scriptId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(()=>{
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(scriptId);
        func();
    }, time);
}
